<template>
  <div id="allrecords" data-tilda-export="yes" class="t-records" data-hook="blocks-collection-content-node"
       data-tilda-project-id="1933100" data-tilda-page-id="14196891" data-tilda-page-alias="background"
       data-tilda-formskey="00da022453d7435b7731ad57b717c0d2">
    <div id="rec241229390" class="r t-rec" style=" " data-animationappear="off" data-record-type="396"><!-- T396 -->
      <div class='t396'>
        <div class="t396__artboard" data-artboard-recid="241229390" data-artboard-height="720"
             data-artboard-height-res-640="740" data-artboard-height-res-480="960" data-artboard-height-res-320="910"
             data-artboard-height_vh="100" data-artboard-height_vh-res-640="100" data-artboard-height_vh-res-320="100"
             data-artboard-valign="top" data-artboard-ovrflw="">
          <div class="t396__carrier" data-artboard-recid="241229390"></div>
          <div class="t396__filter" data-artboard-recid="241229390"></div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208531534 t-animate' data-elem-id='1603208531534'
               data-elem-type='image' data-field-top-value="296" data-field-top-res-960-value="296"
               data-field-top-res-640-value="316" data-field-top-res-480-value="86" data-field-top-res-320-value="85"
               data-field-left-value="-549" data-field-left-res-960-value="-459" data-field-left-res-640-value="-199"
               data-field-left-res-480-value="-190" data-field-left-res-320-value="-130" data-field-width-value="301"
               data-field-width-res-480-value="140" data-field-axisy-value="top" data-field-axisx-value="center"
               data-field-container-value="grid" data-field-topunits-value="px" data-field-leftunits-value="px"
               data-field-heightunits-value="" data-field-widthunits-value="px" data-animate-style="fadeinright"
               data-animate-duration="1" data-animate-delay="0.3" data-animate-distance="100" data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild3662-3261-4863-b133-303530633966__follower2.svg'
                                      imgfield='tn_img_1603208531534'></div>
          </div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208531540 t-animate' data-elem-id='1603208531540'
               data-elem-type='image' data-field-top-value="294" data-field-top-res-960-value="294"
               data-field-top-res-640-value="314" data-field-top-res-480-value="85" data-field-left-value="280"
               data-field-left-res-960-value="258" data-field-left-res-640-value="238" data-field-left-res-480-value="100"
               data-field-width-value="300" data-field-width-res-480-value="140" data-field-axisy-value="top"
               data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value="px"
               data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
               data-animate-style="fadeinleft" data-animate-duration="1" data-animate-distance="100"
               data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild6536-3462-4561-a563-636163643534__greenman.svg'
                                      imgfield='tn_img_1603208531540'></div>
          </div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208531544 t-animate' data-elem-id='1603208531544'
               data-elem-type='image' data-field-top-value="-10" data-field-top-res-640-value="-90"
               data-field-top-res-480-value="-20" data-field-left-value="-470" data-field-left-res-640-value="-260"
               data-field-left-res-480-value="-145" data-field-width-value="99" data-field-width-res-480-value="50"
               data-field-axisy-value="top" data-field-axisx-value="center" data-field-container-value="grid"
               data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
               data-field-widthunits-value="px" data-animate-style="fadeindown" data-animate-duration="1"
               data-animate-delay="0.3" data-animate-distance="100" data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild3133-3536-4136-b263-396535633937__lamp.svg'
                                      imgfield='tn_img_1603208531544'></div>
          </div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208531548 t-animate' data-elem-id='1603208531548'
               data-elem-type='image' data-field-top-value="5" data-field-top-res-640-value="-10"
               data-field-top-res-480-value="5" data-field-left-value="316" data-field-left-res-640-value="186"
               data-field-left-res-480-value="110" data-field-width-value="591" data-field-width-res-480-value="300"
               data-field-axisy-value="top" data-field-axisx-value="center" data-field-container-value="grid"
               data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
               data-field-widthunits-value="px" data-animate-style="zoomin" data-animate-duration="3"
               data-animate-scale="0.9" data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild6363-3564-4433-a138-333538303735__stars.svg'
                                      imgfield='tn_img_1603208531548'></div>
          </div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208531551 t-animate' data-elem-id='1603208531551'
               data-elem-type='image' data-field-top-value="320" data-field-top-res-960-value="320"
               data-field-top-res-640-value="340" data-field-top-res-480-value="84" data-field-left-value="570"
               data-field-left-res-960-value="487" data-field-left-res-640-value="354" data-field-left-res-480-value="175"
               data-field-width-value="254" data-field-width-res-480-value="127" data-field-axisy-value="top"
               data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value="px"
               data-field-leftunits-value="px" data-field-heightunits-value="" data-field-widthunits-value="px"
               data-animate-style="fadeinright" data-animate-duration="1" data-animate-distance="100"
               data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild6239-3938-4537-a537-633933656464__union.svg'
                                      imgfield='tn_img_1603208531551'></div>
          </div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208531555 t-animate' data-elem-id='1603208531555'
               data-elem-type='image' data-field-top-value="215" data-field-top-res-640-value="215"
               data-field-top-res-480-value="80" data-field-top-res-320-value="80" data-field-left-value="-347"
               data-field-left-res-640-value="-237" data-field-left-res-480-value="5" data-field-left-res-320-value="29"
               data-field-width-value="106" data-field-width-res-480-value="80" data-field-width-res-320-value="60"
               data-field-axisy-value="top" data-field-axisx-value="center" data-field-container-value="grid"
               data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
               data-field-widthunits-value="px" data-animate-style="zoomin" data-animate-duration="1"
               data-animate-scale="0.9" data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild6363-3265-4162-b132-656162323033__clock.svg'
                                      imgfield='tn_img_1603208531555'></div>
          </div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208531559 t-animate' data-elem-id='1603208531559'
               data-elem-type='image' data-field-top-value="303" data-field-top-res-960-value="303"
               data-field-top-res-640-value="323" data-field-top-res-480-value="77" data-field-top-res-320-value="75"
               data-field-left-value="-318" data-field-left-res-960-value="-278" data-field-left-res-640-value="-338"
               data-field-left-res-480-value="-100" data-field-left-res-320-value="-60" data-field-width-value="323"
               data-field-width-res-480-value="160" data-field-axisy-value="top" data-field-axisx-value="center"
               data-field-container-value="grid" data-field-topunits-value="px" data-field-leftunits-value="px"
               data-field-heightunits-value="" data-field-widthunits-value="px" data-animate-style="fadeinright"
               data-animate-duration="1" data-animate-delay="0.1" data-animate-distance="100" data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild3164-6363-4530-a138-366434383662__follower1.svg'
                                      imgfield='tn_img_1603208531559'></div>
          </div>
          <div class='t396__elem tn-elem tn-elem__2412293901603208549570 t-animate' data-elem-id='1603208549570'
               data-elem-type='image' data-field-top-value="-20" data-field-top-res-640-value="-65"
               data-field-top-res-480-value="-20" data-field-left-value="-395" data-field-left-res-640-value="-185"
               data-field-left-res-480-value="-105" data-field-width-value="69" data-field-width-res-480-value="30"
               data-field-axisy-value="top" data-field-axisx-value="center" data-field-container-value="grid"
               data-field-topunits-value="px" data-field-leftunits-value="px" data-field-heightunits-value=""
               data-field-widthunits-value="px" data-animate-style="fadeindown" data-animate-duration="1"
               data-animate-delay="0.4" data-animate-distance="100" data-animate-mobile="y">
            <div class='tn-atom'><img class='tn-atom__img t-img'
                                      data-original='images/tilda/subscription-empty-list/tild3133-3536-4136-b263-396535633937__lamp.svg'
                                      imgfield='tn_img_1603208549570'></div>
          </div>
        </div>
      </div><!-- /T396 --></div>
  </div>
</template>

<script>
import loadScripts from './loadScripts';

export default {
  name: 'SubscriptionEmptyListAnimation',
  mixins: [loadScripts],
  mounted() {
    this.injectScripts();
  },
  beforeDestroy() {
    this.removeInjectedScripts();
  },
};
</script>

<style src="./css/tilda-grid-3.0.min.css" scoped></style>
<style src="./css/tilda-blocks-2.12.css" scoped></style>
<style src="./css/tilda-animation-1.0.min.css" scoped></style>
<style src="./css/tilda-slds-1.4.min.css" scoped></style>
<style src="./css/tilda-zoom-2.0.min.css" scoped></style>
<style src="./css/tilda-menusub-1.0.min.css" scoped></style>

<style lang="css" scoped>
#rec241229390 .t396__artboard{min-height: 720px;height: 100vh; background-color: #1E1D2F;}

#rec241229390 .t396__filter{min-height: 720px;height: 100vh;}

#rec241229390 .t396__carrier{min-height: 720px;height: 100vh;background-position: center center;background-attachment: scroll;background-size:cover;background-repeat:no-repeat;}

@media screen and (max-width: 1199px){#rec241229390 .t396__artboard{}#rec241229390 .t396__filter{}#rec241229390 .t396__carrier{background-attachment:scroll;}}

@media screen and (max-width: 959px){#rec241229390 .t396__artboard{min-height: 740px;height: 100vh; background-color: #1E1D2F;}#rec241229390 .t396__filter{min-height: 740px;height: 100vh;}#rec241229390 .t396__carrier{min-height: 740px;height: 100vh;background-position: center center;}}

@media screen and (max-width: 639px){#rec241229390 .t396__artboard{min-height: 960px;}#rec241229390 .t396__filter{min-height: 960px;}#rec241229390 .t396__carrier{min-height: 960px;}}

@media screen and (max-width: 479px){#rec241229390 .t396__artboard{min-height: 910px;height: 100vh; background-color: #1E1D2F;}#rec241229390 .t396__filter{min-height: 910px;height: 100vh;}#rec241229390 .t396__carrier{min-height: 910px;height: 100vh;background-position: center center;}}

#rec241229390 .tn-elem[data-elem-id="1603208531534"]{z-index:2;top: 296px;left: calc(50% - 150.5px + -549px);width:301px;}

#rec241229390 .tn-elem[data-elem-id="1603208531534"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){#rec241229390 .tn-elem[data-elem-id="1603208531534"]{top: 296px;left: calc(50% - 150.5px + -459px);}}

@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208531534"]{top: 316px;left: calc(50% - 150.5px + -199px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208531534"]{top: 86px;left: calc(50% - 70px + -190px);width:140px;}}

@media screen and (max-width: 479px){#rec241229390 .tn-elem[data-elem-id="1603208531534"]{top: 85px;left: calc(50% - 70px + -130px);}}

#rec241229390 .tn-elem[data-elem-id="1603208531540"]{z-index:3;top: 294px;left: calc(50% - 150px + 280px);width:300px;}

#rec241229390 .tn-elem[data-elem-id="1603208531540"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){#rec241229390 .tn-elem[data-elem-id="1603208531540"]{top: 294px;left: calc(50% - 150px + 258px);}}

@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208531540"]{top: 314px;left: calc(50% - 150px + 238px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208531540"]{top: 85px;left: calc(50% - 70px + 100px);width:140px;}}

@media screen and (max-width: 479px){}#rec241229390 .tn-elem[data-elem-id="1603208531544"]{z-index:4;top: -10px;left: calc(50% - 49.5px + -470px);width:99px;}

#rec241229390 .tn-elem[data-elem-id="1603208531544"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){}@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208531544"]{top: -90px;left: calc(50% - 49.5px + -260px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208531544"]{top: -20px;left: calc(50% - 25px + -145px);width:50px;}}

@media screen and (max-width: 479px){}#rec241229390 .tn-elem[data-elem-id="1603208531548"]{z-index:5;top: 5px;left: calc(50% - 295.5px + 316px);width:591px;}

#rec241229390 .tn-elem[data-elem-id="1603208531548"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){}

@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208531548"]{top: -10px;left: calc(50% - 295.5px + 186px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208531548"]{top: 5px;left: calc(50% - 150px + 110px);width:300px;}}

@media screen and (max-width: 479px){}#rec241229390 .tn-elem[data-elem-id="1603208531551"]{z-index:1;top: 320px;left: calc(50% - 127px + 570px);width:254px;}

#rec241229390 .tn-elem[data-elem-id="1603208531551"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){#rec241229390 .tn-elem[data-elem-id="1603208531551"]{top: 320px;left: calc(50% - 127px + 487px);}}

@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208531551"]{top: 340px;left: calc(50% - 127px + 354px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208531551"]{top: 84px;left: calc(50% - 63.5px + 175px);width:127px;}}

@media screen and (max-width: 479px){}#rec241229390 .tn-elem[data-elem-id="1603208531555"]{z-index:6;top: 215px;left: calc(50% - 53px + -347px);width:106px;}

#rec241229390 .tn-elem[data-elem-id="1603208531555"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){}@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208531555"]{top: 215px;left: calc(50% - 53px + -237px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208531555"]{top: 80px;left: calc(50% - 40px + 5px);width:80px;}}

@media screen and (max-width: 479px){#rec241229390 .tn-elem[data-elem-id="1603208531555"]{top: 80px;left: calc(50% - 30px + 29px);width:60px;}}

#rec241229390 .tn-elem[data-elem-id="1603208531559"]{z-index:7;top: 303px;left: calc(50% - 161.5px + -318px);width:323px;}

#rec241229390 .tn-elem[data-elem-id="1603208531559"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){#rec241229390 .tn-elem[data-elem-id="1603208531559"]{top: 303px;left: calc(50% - 161.5px + -278px);}}

@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208531559"]{top: 323px;left: calc(50% - 161.5px + -338px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208531559"]{top: 77px;left: calc(50% - 80px + -100px);width:160px;}}

@media screen and (max-width: 479px){#rec241229390 .tn-elem[data-elem-id="1603208531559"]{top: 75px;left: calc(50% - 80px + -60px);}}

#rec241229390 .tn-elem[data-elem-id="1603208549570"]{z-index:8;top: -20px;left: calc(50% - 34.5px + -395px);width:69px;}

#rec241229390 .tn-elem[data-elem-id="1603208549570"] .tn-atom{background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){}

@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603208549570"]{top: -65px;left: calc(50% - 34.5px + -185px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603208549570"]{top: -20px;left: calc(50% - 15px + -105px);width:30px;}}

@media screen and (max-width: 479px){}

#rec241229390 .tn-elem[data-elem-id="1603277326247"]{color:#ffffff;text-align:center;z-index:9;top: 120px;left: calc(50% - 280px + 0px);width:560px;}

#rec241229390 .tn-elem[data-elem-id="1603277326247"] .tn-atom{color:#ffffff;font-size:56px;font-family:'Montserrat',Arial,sans-serif;line-height:1.2;font-weight:600;background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){}

@media screen and (max-width: 959px){}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603277326247"]{top: 325px;left: calc(50% - 230px + 0px);width:460px;}#rec241229390 .tn-elem[data-elem-id="1603277326247"] .tn-atom{font-size:30px;}}

@media screen and (max-width: 479px){}#rec241229390 .tn-elem[data-elem-id="1603277382793"]{color:#ffffff;text-align:center;z-index:10;top: 290px;left: calc(50% - 150px + 0px);width:300px;}

#rec241229390 .tn-elem[data-elem-id="1603277382793"] .tn-atom{color:#ffffff;font-size:20px;font-family:'Montserrat',Arial,sans-serif;line-height:1.4;font-weight:400;background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){}

@media screen and (max-width: 959px){}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603277382793"]{top: 430px;left: calc(50% - 150px + 0px);}}

@media screen and (max-width: 479px){}

#rec241229390 .tn-elem[data-elem-id="1603277420489"]{color:#ffffff;text-align:center;z-index:11;top: 635px;left: calc(50% - 180px + 0px);width:360px;}

#rec241229390 .tn-elem[data-elem-id="1603277420489"] .tn-atom{color:#ffffff;font-size:16px;font-family:'Montserrat',Arial,sans-serif;line-height:1.4;font-weight:400;opacity:0.7;background-position:center center;border-color:transparent;border-style:solid;}

@media screen and (max-width: 1199px){}

@media screen and (max-width: 959px){#rec241229390 .tn-elem[data-elem-id="1603277420489"]{top: 646px;left: calc(50% - 180px + 0px);}}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603277420489"]{top: 810px;left: calc(50% - 180px + 0px);}}

@media screen and (max-width: 479px){#rec241229390 .tn-elem[data-elem-id="1603277420489"]{top: 780px;left: calc(50% - 150px + 0px);width:300px;}}

#rec241229390 .tn-elem[data-elem-id="1603278687371"]{color:#ffffff;text-align:center;z-index:12;top: 540px;left: calc(50% - 190px + 0px);width:380px;height:65px;}

#rec241229390 .tn-elem[data-elem-id="1603278687371"] .tn-atom{color:#ffffff;font-size:24px;font-family:'Montserrat',Arial,sans-serif;line-height:1.55;font-weight:600;border-width:1px;border-radius:50px;background-color:#cc1ec6;background-position:center center;border-color:transparent;border-style:solid;transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, border-color 0.2s ease-in-out;}

@media screen and (max-width: 1199px){}

@media screen and (max-width: 959px){}

@media screen and (max-width: 639px){#rec241229390 .tn-elem[data-elem-id="1603278687371"]{top: 680px;width:320px;}#rec241229390 .tn-elem[data-elem-id="1603278687371"] .tn-atom{font-size:20px;}}

@media screen and (max-width: 479px){#rec241229390 .tn-elem[data-elem-id="1603278687371"]{width:300px;}}
</style>
